import AutoUnitValueField from "./AutoUnitValueField.mjs";
import Glob from "../../libs/Glob.mjs";

const AutoTimeAmountField = class extends AutoUnitValueField {
	constructor(props) {
		super(props);
		this.state.units = [
			{label:Glob.label('Minutes'),value:"m",multi: 1 },
			{label:Glob.label('Hours'),value:"g",multi: 60 },
			{label:Glob.label('Days'),value:"d",multi: 24 * 60 }
		];
		this.state.multi = 1;
		this.state.min = 0;
		this.state.max = 60;
		this.state.slider = true;
	}
}

export default AutoTimeAmountField;